import { EMAIL_SCHEMA, PASSWORD_SCHEMA } from '@shared/config';
import * as yup from 'yup';

export const singInValidationSchema = yup.object({
  email: EMAIL_SCHEMA,
  password: PASSWORD_SCHEMA,
});

export type SignInRequestData = yup.InferType<typeof singInValidationSchema>;
